import React from "react";
import PropTypes from "prop-types";
import { ALIGNMENT_TYPES, LEFT, RIGHT } from "../sell/constants";
import { handleKeyPress } from "./helpers/keyPressHelpers";

const Toggle = ({ onToggle, alignment }) => {
  return (
    <div
      onKeyPress={(event) => handleKeyPress(event, onToggle)}
      role="button"
      tabIndex={0}
      onClick={onToggle}
      className="lc-toggle"
    >
      <input
        type="checkbox"
        onChange={(event) => handleKeyPress(event, onToggle)}
        className={alignment === RIGHT ? RIGHT : LEFT}
      />
      <span className="slider" aria-label="Slider" />
    </div>
  );
};

Toggle.propTypes = {
  alignment: PropTypes.oneOf(ALIGNMENT_TYPES).isRequired,
  onToggle: PropTypes.func
};

Toggle.defaultProps = {
  onToggle: null
};

export default Toggle;
